import { render, staticRenderFns } from "./ModalCreateGrup.vue?vue&type=template&id=682aff96&scoped=true&"
import script from "./ModalCreateGrup.vue?vue&type=script&lang=js&"
export * from "./ModalCreateGrup.vue?vue&type=script&lang=js&"
import style0 from "./ModalCreateGrup.vue?vue&type=style&index=0&id=682aff96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682aff96",
  null
  
)

export default component.exports